import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { TopMasterKeyComponent } from './components/temp/top-master-key/top-master-key.component';

const routes: Routes = [
  {
    path: '',
    component: TopMasterKeyComponent,
  },
  { path: '**', redirectTo: 'topmasterkey' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class KeyingCombinationRoutingModule {}
